export const sidebarQueryKeys = {
  tableOrganization: ['users', 'me', 'sidebar', 'tables'] as const,
  favorites: ['users', 'me', 'sidebar', 'favorites'] as const,
  hidden: ['users', 'me', 'sidebar', 'hidden'] as const,
  recent: ['users', 'me', 'sidebar', 'recent'] as const,
  /** The sidebar's search: tables or views matching a term. */
  search: (kind: 'tables' | 'views', term: string) => ['sidebar', 'search', kind, term] as const,
}
